export enum ActivityStatusEnums {
    NotStarted = 0,
    InProgress = 1,
    Completed = 2,
    Deferred = 3,
    Cancelled = 4
}

export enum ActivityPriorityEnum {
    High = 0,
    Medium = 1,
    Low = 2
}

export enum ActivityCategoryEnums {
    Meeting = 0,
    Call = 1,
    Email = 2,
    Task = 3,
    FollowUp = 4
}